Ext.define('SA.HistogramNoGeoUnitRequest', {
    extend: 'SA.HistogramRequest',

    constructor() {
        this.hash = 'HistogramNoGeoUnitRequest'; 
        this.result = SA.HistogramResult.withoutData({reason: 'NoGeoUnit'});
        this.resultPromise = Promise.resolve(this.result);
    },

    dispatch() {
        return this.resultPromise;
    }
});